<template>
  <div class="main-view">
    <Toolbar
      :title="$route.name"
      iconType="menu"
      @onClickLeftIcon="onClickLeftIcon"/>
    <transition name="slide">
      <ul class="menu" v-show="isMenuExpaned">
        <li>
          <router-link
            v-on:click.native="isMenuExpaned = false"
            to="/manager-list">新增/編輯/刪除管理者</router-link>
        </li>
        <li>
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/search-log">管理者操作記錄查詢</router-link>
        </li>
        <li>
          <span @click="toggle">服務機制系統設定</span>
          <ul class="nested">
            <li>
              <router-link
                v-on:click.native="isMenuExpaned = false"
                to="/service-list">服務項目管理</router-link>
              </li>
            <li>
              <router-link
                v-on:click.native="isMenuExpaned = false"
                to="/staff-list">服務人員管理</router-link>
              </li>
            <li>
              <router-link
                v-on:click.native="isMenuExpaned = false"
                to="/report-list">服務機制回報查詢</router-link>
              </li>
          </ul>
        </li>
        <li>
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/announcement-permission">公播機制系統權限設定</router-link>
        </li>
        <li>
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/announcement-list">公播機制系統設定</router-link>
        </li>
        <li>
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/search-class">課程資訊導引服務系統</router-link>
        </li>
        <li>
          <a target="_blank" href="https://gate-cpbae.nccu.edu.tw/">門禁系統</a>
        </li>
        <li>
          <router-link
          v-on:click.native="isMenuExpaned = false"
          to="/call-log-list">查詢呼叫紀錄</router-link>
        </li>
        <li>
          <router-link
          v-on:click.native="logout"
          to="/login">登出</router-link>
        </li>
      </ul>
    </transition>
    <router-view/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Toolbar from '@/components/Toolbar.vue'

export default defineComponent({
  name: 'Login',
  components: {
    Toolbar
  },
  data: function () {
    return {
      isMenuExpaned: false
    }
  },
  methods: {
    onClickLeftIcon () {
      this.isMenuExpaned = !this.isMenuExpaned
    },
    toggle (e: Event) {
      const target = e.target as HTMLElement
      target.parentElement?.querySelector('.nested')?.classList.toggle('active')
    },
    alertTodo (text: string) {
      alert(`TODO: ${text}`)
    },
    logout () {
      this.isMenuExpaned = false
      window.localStorage.removeItem('access_token')
    }
  }
})
</script>

<style scoped lang="scss">
  .main-view {
    width: 100vw;
    min-height: calc(100vh - 54px);
    padding-top: 54px;
  }
  .menu {
    width: 300px;
    height: calc(100% - 64px);
    overflow-y: scroll;
    background: white;
    position: absolute;
    user-select: none;
    z-index: 10;
    a, span {
      height: 48px;
      display: flex;
      align-items: center;
      font-size: 18px;
      letter-spacing: 1.13px;
      color: #191919;
      text-decoration: none;
      cursor: pointer;
    }
  }
  ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px;
    a, span {
      padding-left: 40px;
    }
    > li > ul {
      background-color: rgba(222, 204, 142, 0.3);
      a, span {
        padding-left: 54px;
      }
    }
  }
  .slide-enter-active {
    transition: transform .2s ease-in-out;
  }
  .slide-leave-active {
    transition: transform .2s ease-in-out;
  }
  .slide-enter, .slide-leave-to {
    transform: translateX(-300px);
  }
  .slide-enter-to, .slide-leave {
    transform: translateX(0);
  }
  .nested {
    display: block;
    overflow: hidden;
    max-height: 0px;
    transition: max-height .2s ease-in-out;
  }
  .active {
    max-height: 144px;
    transition: max-height .1s ease-in-out;
  }
</style>
